/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Locale_Selectplaceholder1Inputs */

const he_profile_locale_selectplaceholder1 = /** @type {(inputs: Profile_Locale_Selectplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בחרו שפה`)
};

const en_profile_locale_selectplaceholder1 = /** @type {(inputs: Profile_Locale_Selectplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select language`)
};

/**
* | output |
* | --- |
* | "Select language" |
*
* @param {Profile_Locale_Selectplaceholder1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const profile_locale_selectplaceholder1 = /** @type {((inputs?: Profile_Locale_Selectplaceholder1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Locale_Selectplaceholder1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_profile_locale_selectplaceholder1(inputs)
	return en_profile_locale_selectplaceholder1(inputs)
});
export { profile_locale_selectplaceholder1 as "profile_locale_selectPlaceholder" }